/* Framed Grace: lazy, muted video previews without changing link behavior. */
(() => {
  if (window.fgCardMediaInstalled) return;
  window.fgCardMediaInstalled = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let keyboardNavigation = false;
  const active = new Set();
  function stop(link) {
    if (!link) return;
    link.dataset.fgPlayingIntent = '';
    link.classList.remove('fg-video-playing');
    const video = link.querySelector('video.fg-card-video');
    if (video) {
      video.pause();
      try { video.currentTime = 0; } catch (_) {}
    }
    active.delete(link);
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (!entry.isIntersecting) stop(entry.target); });
  }, {threshold: 0.05});
  function play(link) {
    if (!link || motion.matches || document.hidden) return;
    const video = link.querySelector('video.fg-card-video');
    if (!video) return;
    active.forEach(other => { if (other !== link) stop(other); });
    link.dataset.fgPlayingIntent = 'yes';
    video.muted = true;
    video.defaultMuted = true;
    if (!video.dataset.fgLoaded) {
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      video.dataset.fgLoaded = 'yes';
      video.addEventListener('playing', () => {
        if (link.dataset.fgPlayingIntent === 'yes') link.classList.add('fg-video-playing');
        else stop(link);
      });
      video.addEventListener('error', () => stop(link));
      video.addEventListener('waiting', () => link.classList.remove('fg-video-playing'));
      video.load();
      observer.observe(link);
    }
    active.add(link);
    video.play().catch(() => stop(link));
  }
  const cardLink = node => node instanceof Element ? node.closest('a[data-fg-card-video]') : null;
  document.addEventListener('pointerover', event => {
    const link = cardLink(event.target);
    if (event.pointerType === 'mouse' && link && !link.contains(event.relatedTarget)) play(link);
  });
  document.addEventListener('pointerout', event => {
    const link = cardLink(event.target);
    if (link && !link.contains(event.relatedTarget)) stop(link);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') keyboardNavigation = true;
  }, true);
  document.addEventListener('pointerdown', () => { keyboardNavigation = false; }, true);
  document.addEventListener('focusin', event => {
    if (keyboardNavigation) play(cardLink(event.target));
  });
  document.addEventListener('focusout', event => {
    const link = cardLink(event.target);
    if (link && !link.contains(event.relatedTarget)) stop(link);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) [...active].forEach(stop);
  });
  motion.addEventListener('change', () => [...active].forEach(stop));
})();
